import FileOpenIcon from "@mui/icons-material/FileOpen";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import {
  Box,
  Chip,
  Grid,
  Switch,
  TablePagination,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import * as XLSX from 'xlsx';
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import dayjs from "dayjs";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../api";
import { fetchToken } from "../auth/Token";
import { FormatedDateAll } from "../pages/AssociationPassbook";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#f0f0f0",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  width: "337px",
  marginBottom: "32px",
  borderRadius: "8px",
}));

export const MemberPsbb = ({ params }) => {
  const navigate = useNavigate();
  const handlePsb = () => {
    navigate("/Passbook/", {
      state: {
        Member_id: params.row.member_id,
        Fullname: `${params.row.firstname} ${params.row.lastname}`,
        Psb: params.row.association_members_id,
      },
    });
  };
  return (
    <IconButton onClick={handlePsb}>
      <FileOpenIcon />
    </IconButton>
  );
};

const TransactionSummary = (props) => {
  const [checked, setChecked] = useState(false);
  const [mass, setMass] = useState();
  const [dataTMessage, setDataMessage] = useState("");
  const id = props.id;
  const [date, setDate] = useState(dayjs());
  const [start_date, setStart_date] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [start_dateag, setStart_dateag] = useState("");
  const [end_dateag, setEnd_dateag] = useState("");
  const [acc_name, setAcc_name] = useState("");
  const [cash_savings_total, setCash_savings_total] = useState([]);
  const [cash_save_total, setCash_save_total] = useState(null);
  const [cash_loans_total, setCash_loans_total] = useState(null);
  const [disbursed_loans_total, setDisbursed_loans_total] = useState(null);
  const [cash_shares_pur_total, setCash_shares_pur_total] = useState(null);
  const [cash_shares_wit_total, setCash_shares_wit_total] = useState(null);
  const [cash_total, setCash_total] = useState(null);
  const [momo_total, setMomo_total] = useState(null);
  const [withdrawals_total, setWithdrawals_total] = useState(null);
  const [transfer_deposits, setTransfer_deposits] = useState(null);
  const [transfer_withdrawals, setTransfer_withdrawal] = useState(null);
  const [new_data, setNew_data] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const printRef = React.useRef();

  const handlePrint = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    const marginLeft = 20;
    const marginTop = 20;
    const marginRight = 20;
    const marginBottom = 20;

    pdf.addImage(
      data,
      "PNG",
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );

    pdf.save("TransactionalSummary.pdf");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleEcash = () => {
    const cacheKey = `ecash_settings_${props.id}`;
    const cachedData = localStorage.getItem(cacheKey);
  
    if (cachedData) {
      null
    } else {
      const somm = {
        association_id: props.id,
        typee: "savings",
        date: dayjs(),
      };
  
      api
        .post("/association/cash/settings", somm, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          const data = {
            association_id: props.id,
            settings: response.data,
          };
          localStorage.setItem(cacheKey, JSON.stringify(data));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  

  useEffect(() => {
    handleEcash();
  }, [props.id]);

  useEffect(() => {
    setMass();
    handleEcash();
  }, [checked]);

  const transact_sum = () => {
    const cacheKey = `transact_sum_${id}_${date}_${start_date}_${end_date}`;
  
    const cachedData = localStorage.getItem(cacheKey);
  
    if (cachedData) {
      const parsedData = JSON.parse(cachedData);
      setCash_savings_total(parsedData.cash_savings_total);
      setCash_save_total(parsedData.cash_save_total);
      setCash_loans_total(parsedData.cash_loans_total);
      setCash_shares_pur_total(parsedData.cash_shares_pur_total);
      setCash_shares_wit_total(parsedData.cash_shares_wit_total);
      setCash_total(parsedData.cash_total);
      setMomo_total(parsedData.momo_total);
      setWithdrawals_total(parsedData.withdrawals_total);
      setTransfer_deposits(parsedData.transfer_deposits);
      setTransfer_withdrawal(parsedData.transfer_withdrawal);
      setDisbursed_loans_total(parsedData.disbursed_loans_total);
      setDataMessage(); 
      console.log("Data fetched from cache");
    } else {
      const florida = new FormData();
      florida.append("association_id", id);
      florida.append("date", date);
      florida.append("checked", checked);
      florida.append("start_date", start_date);
      florida.append("end_date", end_date);
  
      api
        .post("/association/transaction/sumary/perfect", florida, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          if (!response.data?.message) {
            const dataToCache = {
              cash_savings_total: response.data?.data,
              cash_save_total: response.data?.cash_savings_totalA,
              cash_loans_total: response.data?.cash_loans_totalA,
              cash_shares_pur_total: response.data?.cash_shares_total_purA,
              cash_shares_wit_total: response.data?.cash_shares_total_withA,
              cash_total: response.data?.cash_totalA,
              momo_total: response.data?.momo_totalA,
              withdrawals_total: response.data?.withdrawals_totalA,
              transfer_deposits: response.data?.transfer_depositsA,
              transfer_withdrawal: response.data?.transfer_withdrawalsA,
              disbursed_loans_total: response.data?.loan_disbursedA,
            };
  
            localStorage.setItem(cacheKey, JSON.stringify(dataToCache));
  
            setCash_savings_total(response.data?.data);
            setCash_save_total(response.data?.cash_savings_totalA);
            setCash_loans_total(response.data?.cash_loans_totalA);
            setCash_shares_pur_total(response.data?.cash_shares_total_purA);
            setCash_shares_wit_total(response.data?.cash_shares_total_withA);
            setCash_total(response.data?.cash_totalA);
            setMomo_total(response.data?.momo_totalA);
            setWithdrawals_total(response.data?.withdrawals_totalA);
            setTransfer_deposits(response.data?.transfer_depositsA);
            setTransfer_withdrawal(response.data?.transfer_withdrawalsA);
            setDisbursed_loans_total(response.data?.loan_disbursedA);
            setDataMessage();
          } else {
            setDataMessage("No data found for this period");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  
  // console.log(cash_savings_total)
  const fetch_new_data = (account_id, type) => {
    const maimi = new FormData();
    maimi.append("association_id", id);
    maimi.append("account_id", account_id);
    maimi.append("account_type", type);
    maimi.append("date", date);
    maimi.append("checked", checked);
    maimi.append("start_date", start_date);
    maimi.append("end_date", end_date);
    api
      .post("/association/transaction/sumary/accounts", maimi, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        if (response.data === "Invalid Account") {
          toast.error(response.data);
        } else {
          setNew_data(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const transact_sum_form = (e) => {
    e.preventDefault();
    const florida = new FormData();
    florida.append("association_id", id);
    florida.append("date", date);
    florida.append("checked", checked);
    florida.append("start_date", start_date);
    florida.append("end_date", end_date);
    api
      .post("/association/transaction/sumary/perfect", florida, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        if (!response.data?.message) {
          setDataMessage();
          setCash_savings_total(response.data?.data);
          setCash_save_total(response.data?.cash_savings_totalA);
          setCash_loans_total(response.data?.cash_loans_totalA);
          setCash_shares_pur_total(response.data?.cash_shares_total_purA);
          setCash_shares_wit_total(response.data?.cash_shares_total_withA);
          setCash_total(response.data?.cash_totalA);
          setMomo_total(response.data?.momo_totalA);
          setWithdrawals_total(response.data?.withdrawals_totalA);
          setTransfer_deposits(response.data?.transfer_depositsA);
          setTransfer_withdrawal(response.data?.transfer_withdrawalsA);
          setDisbursed_loans_total(response.data?.loan_disbursedA);
        } else {
          setDataMessage("No data found for this period");
          toast.warning("No data found for this period");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  // const transact_sum_filtered = () => {
  //   const florida = new FormData()
  //   florida.append('association_id', id)
  //   florida.append('start_date', start_date)
  //   florida.append('end_date', end_date)
  //   api.post(`/association/transaction/sumary`, florida, {
  //     headers: {
  //       Authorization: 'Bearer '+fetchToken()
  //     },
  //   }).then(function (response){
  //       setDataTransaction(response.data?.data);
  //   }).catch(function (error){
  //     console.log(error)
  //   })
  // }

  useEffect(() => {
    transact_sum();
  }, [id, date]);

  const [total_wit, setTotal_wit] = useState();
  const [total_dep, setTotal_dep] = useState();
  const [typee, setTypee] = useState("savings");

  const ClickActions = () => {
    const som = {
      association_id: id,
      date: date,
      checked: checked,
      start_date: start_date,
      end_date: end_date,
      typee: typee,
    };
    api
      .post("/association/today/everything", som, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setMass(response.data?.All_One);
        setTotal_wit(response.data?.total_wit);
        setTotal_dep(response.data?.total_dep);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const ClickActionsag = (e) => {
    e.preventDefault();
    const som = {
      association_id: id,
      date: date,
      checked: checked,
      start_date: start_dateag,
      end_date: end_dateag,
      typee: typee,
      acc_name: acc_name,
    };
    api
      .post("/association/today/everything/fil", som, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setMass(response.data?.All_One);
        setTotal_wit(response.data?.total_wit);
        setTotal_dep(response.data?.total_dep);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const ClickActionsab = () => {
    const som = {
      association_id: id,
      date: date,
      checked: checked,
      start_date: start_dateag,
      end_date: end_dateag,
      typee: typee,
      acc_name: acc_name,
    };
    api
      .post("/association/today/everything/fil", som, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setMass(response.data?.All_One);
        setTotal_wit(response.data?.total_wit);
        setTotal_dep(response.data?.total_dep);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (acc_name !== "") {
      ClickActionsab();
    }
  }, [acc_name]);

  const whatisit = (type) => {
    setTypee(type);
    ClickActions();
  };

  const TodayColumns = [
    {
      field: "transaction_date",
      headerName: "DateTime",
      flex: 1,
      width: 50,
      renderCell: (params) => (
        <FormatedDateAll value={params.row.transaction_date} />
      ),
    },
    {
      field: "id",
      headerName: "Id",
      flex: 1,
    },
    {
      field: "transaction_id",
      headerName: "transaction_id",
      flex: 1,
    },
    {
      field: "firstname",
      headerName: "Member Name",
      flex: 1,
      renderCell: (params) => `${params.row.firstname} ${params.row.lastname}`,
    },
    {
      field: "association_members_id",
      headerName: "bond_id",
      flex: 1,
    },
    {
      field: "passbook_id",
      headerName: "Passbook Number",
      flex: 1,
    },
    {
      field: "lastname",
      headerName: "Lastname",
      flex: 1,
    },
    {
      field: "member_id",
      headerName: "Member id",
      flex: 1,
    },
    {
      field: "debit",
      headerName: "Debit(GHS)",
      flex: 1,
      width: 70,
      renderCell: (params) =>
        params.row.transactiontype_name === "Withdraw" ? params.row.amount : 0,
    },
    {
      field: "credit",
      headerName: "Credit(GHS)",
      flex: 1,
      width: 70,
      renderCell: (params) =>
        params.row.transactiontype_name === "Deposit" ? params.row.amount : 0,
    },
    {
      field: "narration",
      headerName: "Narration",
      flex: 1,
      width: 70,
    },
    {
      field: "transactiontype_name",
      headerName: "Type",
      flex: 1,
    },
    {
      field: "amount",
      headerName: "Amount(GHS)",
      flex: 1,
    },
    {
      field: "account_name",
      headerName: "Account",
      flex: 1,
    },
    {
      field: "do",
      type: "actions",
      renderCell: (params) => <MemberPsbb {...{ params }} />,
    },
  ];

  const handledate = (value) => {
    setMass();
    setDate(value);
  };

  const handleFormChange = (event) => {
    setChecked(event.target.checked);
  };

  const exportToExcel = () => {
    const title =  `${props.name}'s Transactional Summary`; 
    const headers = [
      "Date", "Cash Deposits", "Cash Withdrawals", "Loan Repayments",
      "Loan Disbursed", "Shares Purchased", "Shares Withdrawals",
      "Transfer Deposits", "E-cash Deposits"
    ];
  
    // Prepare data with header rows
    const data = cash_savings_total?.filter(row =>
      row.cash_savings_total !== 0 ||
      row.withdrawals_total !== 0 ||
      row.cash_loans_total !== 0 ||
      row.loan_disbursed !== 0 ||
      row.cash_shares_total_pur !== 0 ||
      row.cash_shares_total_with !== 0 ||
      row.transfer_deposits !== 0 ||
      row.ecash_bal !== 0
    ).map(row => [
      row.date,
      row.cash_savings_total,
      row.withdrawals_total,
      row.cash_loans_total,
      row.loan_disbursed,
      row.cash_shares_total_pur,
      row.cash_shares_total_with,
      row.transfer_deposits,
      row.ecash_bal,
    ]);
  
    // Combine title, headers, and data into worksheet
    const worksheetData = [[title], [], headers, ...data];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    
    // Merge title row cells
    XLSX.utils.sheet_add_aoa(worksheet, [[title]], { origin: "A1" });
    worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
    
    // Style title row (optional)
    worksheet["A1"].s = {
      font: { bold: true, sz: 16 },
      alignment: { vertical: "center", horizontal: "center" },
    };
  
    // Create workbook and add the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
    // Export to Excel
    XLSX.writeFile(workbook, "TransactionSummary.xlsx");
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div>
        <Box sx={{ m: "40px 0 0 0", height: "75vh", paddingBottom: "35px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Item>
                <div style={{ display: "flex" }}>
                  <Typography
                    sx={{ margin: "5px", color: "#003049" }}
                    fontStyle="normal"
                    variant="h6"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Use period</b>
                  </Typography>
                  <Switch
                    checked={checked}
                    onChange={handleFormChange}
                    sx={{ color: "#001845" }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
                {checked === true ? (
                  <>
                    <Typography>Filter Date</Typography>
                    <div style={{ display: "flex" }}>
                      <form onSubmit={transact_sum_form}>
                        <TextField
                          type="date"
                          size="small"
                          required
                          variant="outlined"
                          helperText="From"
                          name="start_date"
                          onChange={(e) => setStart_date(e.target.value)}
                          value={start_date}
                          sx={{ mr: 1 }}
                        />

                        <TextField
                          type="date"
                          size="small"
                          required
                          variant="outlined"
                          helperText="To"
                          name="end_date"
                          onChange={(e) => setEnd_date(e.target.value)}
                          value={end_date}
                          sx={{ mr: 1 }}
                        />

                        <IconButton type="submit">
                          <FilterAltOutlinedIcon />
                        </IconButton>
                        {/* <IconButton onClick={transact_sum}><CancelIcon /></IconButton> */}
                      </form>
                    </div>

                    <Typography
                      sx={{ m: 2 }}
                      variant="h5"
                      fontStyle="normal"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b style={{ color: "#001d3d" }}>
                        View individual transactions
                      </b>
                      <IconButton onClick={ClickActions}>
                        <ReceiptLongIcon fontSize="large" />
                      </IconButton>
                    </Typography>
                  </>
                ) : (
                  <div>
                    <StaticDatePicker
                      sx={{ width: 125, height: 425 }}
                      value={date}
                      onChange={(new_value) => handledate(new_value)}
                    />
                    <Typography
                      sx={{ m: 2 }}
                      variant="h5"
                      fontStyle="normal"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b style={{ color: "#001d3d" }}>
                        View individual transactions
                      </b>
                      <IconButton onClick={ClickActions}>
                        <ReceiptLongIcon fontSize="large" />
                      </IconButton>
                    </Typography>
                  </div>
                )}
              </Item>
            </Grid>
            {/* test to see if it prints excel or image */}
            {/* it's original excel!!😂 */}
            <Grid item xs={12} md={12}>
              <Chip
                size="medium"
                label={
                  <Typography
                    variant="subtitle"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Print</b>
                  </Typography>
                }
                sx={{
                  borderRadius: 2,
                  mr: "auto",
                  boxShadow:
                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "orange",
                  color: "#000",
                  "&:hover": {
                    boxShadow:
                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                    backgroundColor: "#14213d",
                    color: "#fff",
                  },
                }}
                // onClick={handlePrint}
                onClick={exportToExcel}
              />
              <div ref={printRef}>
                <Typography
                  sx={{ textAlign: "center" }}
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>Transaction Summary</b>
                </Typography>

                <Box
                  sx={{
                    overflowX: "auto",
                    maxHeight: 540,
                    overflowY: "auto",
                    "&::-webkit-scrollbar": {
                      width: "7px",
                      height: "7px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#888",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "#555",
                    },
                  }}
                >
                  <Table
                    size="small"
                    aria-label="a dense table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            Date
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            Cash Deposits
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            Cash Withdrawals
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            Loan Repayments
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            Loan Disbursed
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            Shares Purchased
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            Shares Withdrawals
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            Transfer Deposits
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            E-cash Deposits
                          </Typography>{" "}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {cash_savings_total?.filter(
                        (row) =>
                          row.cash_savings_total !== 0 ||
                          row.withdrawals_total !== 0 ||
                          row.cash_loans_total !== 0 ||
                          row.loan_disbursed !== 0 ||
                          row.cash_shares_total_pur !== 0 ||
                          row.cash_shares_total_with !== 0 ||
                          row.transfer_deposits !== 0 ||
                          row.ecash_bal !== 0
                      )
                      .map((row) => (
                        <TableRow
                          key={row.transaction_id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                            backgroundColor: "#f5f3f4",
                          }}
                        >
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>{row.date}</b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                {currencyFormat.format(row.cash_savings_total)}
                              </b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                {currencyFormat.format(row.withdrawals_total)}
                              </b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                {currencyFormat.format(row.cash_loans_total)}
                              </b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>{currencyFormat.format(row.loan_disbursed)}</b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                {currencyFormat.format(
                                  row.cash_shares_total_pur
                                )}
                              </b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                {currencyFormat.format(
                                  row.cash_shares_total_with
                                )}
                              </b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                {currencyFormat.format(row.transfer_deposits)}
                              </b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>{currencyFormat.format(row.ecash_bal)}</b>
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow
                        key={0}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          backgroundColor: "#f5f3f4",
                        }}
                      >
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Total</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              {currencyFormat.format(
                                cash_save_total ? cash_save_total : 0
                              )}
                            </b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              {currencyFormat.format(
                                withdrawals_total ? withdrawals_total : 0
                              )}
                            </b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              {currencyFormat.format(
                                cash_loans_total ? cash_loans_total : 0
                              )}
                            </b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              {currencyFormat.format(
                                disbursed_loans_total
                                  ? disbursed_loans_total
                                  : 0
                              )}
                            </b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              {currencyFormat.format(
                                cash_shares_pur_total
                                  ? cash_shares_pur_total
                                  : 0
                              )}
                            </b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              {currencyFormat.format(
                                cash_shares_wit_total
                                  ? cash_shares_wit_total
                                  : 0
                              )}
                            </b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              {currencyFormat.format(
                                transfer_deposits ? transfer_deposits : 0
                              )}
                            </b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              {currencyFormat.format(
                                momo_total ? momo_total : 0
                              )}
                            </b>
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  {/* <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={cash_savings_total.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    /> */}
                </Box>
              </div>
              <Box sx={{ mt: 3, mb: 7 }}>
                <Accordion sx={{ borderRadius: 2, mb: 2 }}>
                  <AccordionSummary
                    expandIcon={<KeyboardDoubleArrowDownIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Savings accounts</b>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      {props.all_accounts?.savings.map((item) => (
                        <Chip
                          onClick={() => fetch_new_data(item.id, "savings")}
                          variant="contained"
                          sx={{
                            backgroundColor: "#012a4a",
                            color: "#fff",
                            m: "5px",
                          }}
                          label={item.account_name}
                        />
                      ))}
                    </div>
                  </AccordionDetails>
                  {new_data && new_data.type === "savings" ? (
                    <Box sx={{ m: 1 }}>
                      <Typography
                        sx={{ textAlign: "center" }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="h3"
                      >
                        <b>{new_data.account_name}</b>
                      </Typography>
                      <Grid container>
                        <Grid item xs={12} md={6}>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            {" "}
                            <b>
                              Current Balance:{" "}
                              {currencyFormat.format(
                                new_data.association_all_time_total
                              )}
                            </b>
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            {" "}
                            <b>
                              Balance for selected{" "}
                              {checked === true ? "period" : "date"}:{" "}
                              {currencyFormat.format(
                                new_data.selected_date_total
                              )}
                            </b>
                          </Typography>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <Box
                            sx={{
                              maxWidth: 750,
                              overflowX: "auto",
                              maxHeight: 540,
                              overflowY: "auto",
                              "&::-webkit-scrollbar": {
                                width: "7px",
                              },
                              "&::-webkit-scrollbar-track": {
                                background: "#f1f1f1",
                              },
                              "&::-webkit-scrollbar-thumb": {
                                background: "#888",
                                borderRadius: "10px",
                              },
                              "&::-webkit-scrollbar-thumb:hover": {
                                background: "#555",
                              },
                            }}
                          >
                            <Table
                              sx={{ width: 999 }}
                              size="small"
                              aria-label="a dense table"
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Date
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Member
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Passbook Id
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Debit
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Credit
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Narration
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Balance
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Prepared by
                                    </Typography>{" "}
                                  </TableCell>
                                  {/* <TableCell align="left">Open Price</TableCell> */}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {new_data?.transactions
                                  .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                  )
                                  .map((row) => (
                                    <TableRow
                                      key={row.transaction_id}
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                        backgroundColor: "#f5f3f4",
                                      }}
                                    >
                                      <TableCell align="left">
                                        <FormatedDateAll
                                          value={row.transaction_date}
                                        />
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            {row.firstname} {row.lastname}
                                          </b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{row.passbook_id}</b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <b>
                                          {row.transactiontype_id === 2
                                            ? currencyFormat.format(row.amount)
                                            : currencyFormat.format(0)}
                                        </b>
                                      </TableCell>
                                      <TableCell align="left">
                                        <b>
                                          {row.transactiontype_id === 1
                                            ? currencyFormat.format(row.amount)
                                            : currencyFormat.format(0)}
                                        </b>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{row.narration}</b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <b>
                                          {currencyFormat.format(row.balance)}
                                        </b>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{row.username}</b>
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                            <TablePagination
                              rowsPerPageOptions={[10, 25, 100]}
                              component="div"
                              count={new_data?.transactions.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  ) : null}
                </Accordion>
                <Accordion sx={{ borderRadius: 2, mb: 2 }}>
                  <AccordionSummary
                    expandIcon={<KeyboardDoubleArrowDownIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Loans accounts</b>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      {props.all_accounts?.loans.map((item) => (
                        <Chip
                          onClick={() => fetch_new_data(item.id, "loans")}
                          variant="contained"
                          sx={{
                            backgroundColor: "#013a63",
                            color: "#fff",
                            m: "5px",
                          }}
                          label={item.account_name}
                        />
                      ))}
                    </div>
                  </AccordionDetails>
                  {new_data && new_data.type === "loans" ? (
                    <Box sx={{ m: 1 }}>
                      <Typography
                        sx={{ textAlign: "center" }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="h3"
                      >
                        <b>{new_data.account_name}</b>
                      </Typography>
                      <Grid container>
                        <Grid item xs={12} md={6}>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            {" "}
                            <b>
                              Current Balance:{" "}
                              {currencyFormat.format(
                                new_data.association_all_time_total
                              )}
                            </b>
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            {" "}
                            <b>
                              Balance for selected{" "}
                              {checked === true ? "period" : "date"}:{" "}
                              {currencyFormat.format(
                                new_data.selected_date_total
                              )}
                            </b>
                          </Typography>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <Box
                            sx={{
                              maxWidth: 850,
                              overflowX: "auto",
                              maxHeight: 540,
                              overflowY: "auto",
                              "&::-webkit-scrollbar": {
                                width: "7px",
                              },
                              "&::-webkit-scrollbar-track": {
                                background: "#f1f1f1",
                              },
                              "&::-webkit-scrollbar-thumb": {
                                background: "#888",
                                borderRadius: "10px",
                              },
                              "&::-webkit-scrollbar-thumb:hover": {
                                background: "#555",
                              },
                            }}
                          >
                            <Table
                              sx={{ width: 999 }}
                              size="small"
                              aria-label="a dense table"
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Date
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Member
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Passbook Id
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Debit
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Credit
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Status
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Narration
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Balance
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Prepared by
                                    </Typography>{" "}
                                  </TableCell>
                                  {/* <TableCell align="left">Open Price</TableCell> */}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {new_data?.transactions
                                  .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                  )
                                  .map((row) => (
                                    <TableRow
                                      key={row.transaction_id}
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                        backgroundColor: "#f5f3f4",
                                      }}
                                    >
                                      <TableCell align="left">
                                        <FormatedDateAll
                                          value={row.transaction_date}
                                        />
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            {row.firstname} {row.lastname}
                                          </b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{row.passbook_id}</b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <b>
                                          {row.transactiontype_id === 2
                                            ? currencyFormat.format(row.amount)
                                            : currencyFormat.format(0)}
                                        </b>
                                      </TableCell>
                                      <TableCell align="left">
                                        <b>
                                          {row.transactiontype_id === 1
                                            ? currencyFormat.format(row.amount)
                                            : currencyFormat.format(0)}
                                        </b>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{row.status}</b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{row.narration}</b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <b>
                                          {currencyFormat.format(row.balance)}
                                        </b>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{row.username}</b>
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                            <TablePagination
                              rowsPerPageOptions={[10, 25, 100]}
                              component="div"
                              count={new_data?.transactions.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  ) : null}
                </Accordion>
                <Accordion sx={{ borderRadius: 2, mb: 2 }}>
                  <AccordionSummary
                    expandIcon={<KeyboardDoubleArrowDownIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Shares accounts</b>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      {props.all_accounts?.shares.map((item) => (
                        <Chip
                          onClick={() => fetch_new_data(item.id, "shares")}
                          variant="contained"
                          sx={{
                            backgroundColor: "#01497c",
                            color: "#fff",
                            m: "5px",
                          }}
                          label={item.account_name}
                        />
                      ))}
                    </div>
                  </AccordionDetails>
                  {new_data && new_data.type === "shares" ? (
                    <Box sx={{ m: 1 }}>
                      <Typography
                        sx={{ textAlign: "center" }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="h3"
                      >
                        <b>{new_data.account_name}</b>
                      </Typography>
                      <Grid container>
                        <Grid item xs={12} md={6}>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            {" "}
                            <b>
                              Current Balance:{" "}
                              {currencyFormat.format(
                                new_data.association_all_time_total
                              )}
                            </b>
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            {" "}
                            <b>
                              Balance for selected{" "}
                              {checked === true ? "period" : "date"}:{" "}
                              {currencyFormat.format(
                                new_data.selected_date_total
                              )}
                            </b>
                          </Typography>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <Box
                            sx={{
                              maxWidth: 850,
                              overflowX: "auto",
                              maxHeight: 540,
                              overflowY: "auto",
                              "&::-webkit-scrollbar": {
                                width: "7px",
                              },
                              "&::-webkit-scrollbar-track": {
                                background: "#f1f1f1",
                              },
                              "&::-webkit-scrollbar-thumb": {
                                background: "#888",
                                borderRadius: "10px",
                              },
                              "&::-webkit-scrollbar-thumb:hover": {
                                background: "#555",
                              },
                            }}
                          >
                            <Table
                              sx={{ width: 999 }}
                              size="small"
                              aria-label="a dense table"
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Date
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Member
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Passbook Id
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Debit
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Credit
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Narration
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Balance
                                    </Typography>{" "}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Prepared by
                                    </Typography>{" "}
                                  </TableCell>
                                  {/* <TableCell align="left">Open Price</TableCell> */}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {new_data?.transactions
                                  .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                  )
                                  .map((row) => (
                                    <TableRow
                                      key={row.transaction_id}
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                        backgroundColor: "#f5f3f4",
                                      }}
                                    >
                                      <TableCell align="left">
                                        {row.transaction_id}
                                      </TableCell>
                                      <TableCell align="left">
                                        <FormatedDateAll
                                          value={row.transaction_date}
                                        />
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            {row.firstname} {row.lastname}
                                          </b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{row.passbook_id}</b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <b>
                                          {row.transactiontype_id === 2
                                            ? currencyFormat.format(row.amount)
                                            : currencyFormat.format(0)}
                                        </b>
                                      </TableCell>
                                      <TableCell align="left">
                                        <b>
                                          {row.transactiontype_id === 1
                                            ? currencyFormat.format(row.amount)
                                            : currencyFormat.format(0)}
                                        </b>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{row.narration}</b>
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="left">
                                        <b>
                                          {currencyFormat.format(row.balance)}
                                        </b>
                                      </TableCell>
                                      <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{row.username}</b>
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                            <TablePagination
                              rowsPerPageOptions={[10, 25, 100]}
                              component="div"
                              count={new_data?.transactions.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  ) : null}
                </Accordion>
              </Box>

              {dataTMessage ? (
                <Typography
                  variant="h4"
                  fontStyle="normal"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>{dataTMessage}</b>
                </Typography>
              ) : (
                <div style={{ display: "block" }}></div>
              )}
            </Grid>
          </Grid>

          {mass ? (
            <div style={{ marginBottom: "100px" }}>
              <Tooltip title="Double Click" placement="top">
                <div style={{ display: "flex" }}>
                  <Chip
                    variant="contained"
                    onClick={() => whatisit("savings")}
                    sx={{ backgroundColor: "#012a4a", color: "#fff", m: "5px" }}
                    label="Savings acc Transactions"
                  />
                  <Chip
                    variant="contained"
                    onClick={() => whatisit("share")}
                    sx={{ backgroundColor: "#013a63", color: "#fff", m: "5px" }}
                    label="Shares acc Transactions"
                  />
                  <Chip
                    variant="contained"
                    onClick={() => whatisit("loan")}
                    sx={{ backgroundColor: "#01497c", color: "#fff", m: "5px" }}
                    label="Loan acc Transactions"
                  />
                  <Chip
                    variant="contained"
                    onClick={() => whatisit("transfer")}
                    sx={{ backgroundColor: "#014f86", color: "#fff", m: "5px" }}
                    label="Transfers Transactions"
                  />
                </div>
              </Tooltip>

              <div>
                <Typography
                  variant="subtitle"
                  fontStyle="normal"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  sx={{ textAlign: "center" }}
                >
                  <b>
                    Current table: <i>{typee} transactions</i>
                  </b>
                </Typography>
              </div>
              <Box>
                <Typography>Filter Date</Typography>
                <div style={{ display: "flex" }}>
                  <form onSubmit={ClickActionsag}>
                    <TextField
                      type="date"
                      size="small"
                      required
                      variant="outlined"
                      helperText="From"
                      name="start_dateag"
                      onChange={(e) => setStart_dateag(e.target.value)}
                      value={start_dateag}
                      sx={{ mr: 1 }}
                    />

                    <TextField
                      type="date"
                      size="small"
                      required
                      variant="outlined"
                      helperText="To"
                      name="end_dateag"
                      onChange={(e) => setEnd_dateag(e.target.value)}
                      value={end_dateag}
                      sx={{ mr: 1 }}
                    />

                    <IconButton type="submit">
                      <FilterAltOutlinedIcon />
                    </IconButton>
                  </form>
                </div>
                <TextField
                  size="small"
                  variant="outlined"
                  helperText="Account"
                  name="acc_name"
                  onChange={(e) => setAcc_name(e.target.value)}
                  value={acc_name}
                  sx={{ mr: 1 }}
                />
              </Box>
              <DataGrid
                rows={mass}
                columns={TodayColumns}
                autoHeight
                checkboxSelection
                getRowId={(row) => row.transaction_id}
                slots={{ toolbar: GridToolbar }}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      id: false,
                      transaction_id: false,
                      lastname: false,
                      member_id: false,
                      amount: false,
                      username: false,
                      transactiontype_name: false,
                      association_members_id: false,
                    },
                  },
                  pagination: { paginationModel: { pageSize: 5 } },
                }}
                pageSizeOptions={[5, 10, 25]}
              />
              <div>
                <div
                  style={{
                    display: "flex",
                    padding: "4px",
                    marginBottom: "35px",
                    marginTop: "5px",
                  }}
                >
                  <Typography variant="h5" sx={{ color: "red", mr: 4 }}>
                    Total:
                  </Typography>
                  <Typography variant="h5" sx={{ color: "darkblue", mr: 4 }}>
                    Debit: {total_wit}{" "}
                  </Typography>
                  <Typography variant="h5" sx={{ color: "darkblue", mr: 4 }}>
                    Credit: {total_dep}{" "}
                  </Typography>
                </div>
              </div>
            </div>
          ) : null}
        </Box>
      </div>
    </LocalizationProvider>
  );
};

export default TransactionSummary;
